module.exports = __webpack_public_path__ + "media/images/lb/507-4ce436caf6406b17468fc62958020edd.svg";